import i18n from 'i18next';
import {  initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../../copy/en.json';
import ru from '../../copy/ru.json';


export const defaultNS = "en";

export const translationJson = {
  en: {
    translation:  en ,
    name: 'en'
  },
  ru: {
    translation:  ru ,
    name: 'ru'
  },
} as const;


i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
  debug: true,
  fallbackLng: 'en',
  resources: translationJson,
});
export default i18n;